export const RELEVANCE_FILTER_I18N_PREFIX = "features.home.components.comment_filter.relevance_filter";

export const RELEVANCE_FILTER_I18N_KEYS = {
  relevance_filter_button_label: "relevance_filter_button_label",
  relevance_filter_option:       "relevance_filter_option",
  irrelevance_filter_option:     "irrelevance_filter_option"
}


// WEBPACK FOOTER //
// ./src/features/home/components/comment-filter/constants/i18n/RelevanceFilteri18nConstants.js